import axios, {AxiosResponse} from 'axios';
import {TimeSeriesEntry} from './TimeSeriesEntry';
import {DateRange} from '../stores/TimeIntervalStore';
import {handleError} from './errorHandling';
import {convertCamelCaseToSnakeCase} from '../utility/ApiParamConversion';
import {KPI} from '../kpi';

export interface TimeSeriesRequest {
    channel: string;
    productId: string;
    kpi: KPI;
    interval: DateRange;
    targetCurrency?: string;
    testId?: string;
    variantId?: string;
}

export interface ChannelTimeSeriesRequest {
    channel: string;
    kpi: KPI;
    interval: DateRange;
    targetCurrency?: string;
    testId?: string;
    variantId?: string;
}

export function getHourlyProductDataSummary(request: ChannelTimeSeriesRequest): Promise<AxiosResponse<TimeSeriesEntry[]>> {
    const {channel, kpi, ...requestQueryParams} = request;
    return axios
        .get(`product/${channel}/hourly/${convertCamelCaseToSnakeCase(kpi)}/summary`, {params: requestQueryParams})
        .catch(handleError('error:loadingOfProductChannelDiagramDataFailed'));
}

export function getHourlyProductData(request: TimeSeriesRequest): Promise<AxiosResponse<TimeSeriesEntry[]>> {
    const {channel, kpi, ...requestQueryParams} = request;
    return axios
        .get(`product/${channel}/hourly/${convertCamelCaseToSnakeCase(kpi)}`, {params: requestQueryParams})
        .catch(handleError('error:loadingOfProductDiagramFailed'));
}

export function getDailyProductDataSummary(request: ChannelTimeSeriesRequest): Promise<AxiosResponse<TimeSeriesEntry[]>> {
    const {channel, kpi, ...requestQueryParams} = request;
    return axios
        .get(`product/${channel}/daily/${convertCamelCaseToSnakeCase(kpi)}/summary`, {params: requestQueryParams})
        .catch(handleError('error:loadingOfProductChannelDiagramDataFailed'));
}

export function getDailyProductData(request: TimeSeriesRequest): Promise<AxiosResponse<TimeSeriesEntry[]>> {
    const {channel, kpi, ...requestQueryParams} = request;
    return axios
        .get(`product/${channel}/daily/${convertCamelCaseToSnakeCase(kpi)}`, {params: requestQueryParams})
        .catch(handleError('error:loadingOfProductDiagramFailed'));
}



// WEBPACK FOOTER //
// ./src/apis/ProductAPI.ts